import React, { useMemo } from 'react';
import { createHashHistory } from 'history';
import axios from 'axios';
import { ApplicationAuthConfig } from '@tanium-cloud/tsp-contracts';
import { Box } from '@tanium/react-box';
import { Stack } from '@tanium/react-stack';
import { useTranslation } from 'react-i18next';
import { AppWrapper } from './AppWrapper';
import '../../i18n';
import { AsyncStateData } from '../../hooks/useAsync';
import { useApiResponse } from '../../hooks/useApiResponse';
import { useAsyncEffect } from '../../hooks/useAsyncEffect';
import { AppContainer } from './AppContainer';
import { AsyncSuspense } from '../AsyncSuspense';
import { TaniumLoginCard } from '../../pages/Login/TaniumLoginCard';
import { FullPageSpinner } from '../FullPageSpinner';

const useAuthConfig = (): AsyncStateData<ApplicationAuthConfig, Error> => {
  const response = useApiResponse<ApplicationAuthConfig>('/authconfig', {
    axiosInstance: axios,
  });

  useAsyncEffect(response, []);
  return response;
};

const AuthErrorPage: React.VFC<{ error: string }> = ({ error }) => {
  return (
    <Box as={Stack} justifyContent="center" marginTop="150px">
      <TaniumLoginCard>{error}</TaniumLoginCard>
    </Box>
  );
};

export const App: React.VFC = () => {
  const { t } = useTranslation('app');
  const history = useMemo(() => createHashHistory(), []);
  const authConfigState = useAuthConfig();

  return (
    <AppWrapper history={history}>
      <AsyncSuspense
        state={authConfigState}
        loading={<FullPageSpinner />}
        failure={<AuthErrorPage error={t('authConfigError')} />}
      >
        <AppContainer authConfig={authConfigState.value!} />
      </AsyncSuspense>
    </AppWrapper>
  );
};
